import React from 'react';

const UserIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 187 186"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M93.5 0C42.204 0 0.642883 41.625 0.642883 93C0.642883 144.375 42.204 186 93.5 186C144.796 186 186.357 144.375 186.357 93C186.357 41.625 144.796 0 93.5 0ZM93.5 36C111.697 36 126.449 50.775 126.449 69.0001C126.449 87.225 111.697 102 93.5 102C75.303 102 60.5507 87.225 60.5507 69.0001C60.5507 50.775 75.303 36 93.5 36ZM93.5 165C71.5213 165 51.8267 155.025 38.6469 139.425C45.6861 126.15 59.4649 117 75.5277 117C76.4263 117 77.3249 117.15 78.1861 117.413C83.0536 118.988 88.1458 120 93.5 120C98.8542 120 103.984 118.988 108.814 117.413C109.675 117.15 110.574 117 111.473 117C127.535 117 141.314 126.15 148.354 139.425C135.173 155.025 115.478 165 93.5 165Z"
        fill="#878C97"
      />
    </svg>
  );
};

export default UserIcon;
